import React from "react";
import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../stores/UserStore";

const BoardToken = "0863baab-6a00-eb33-2055-12b62e533a70";

class Feedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rendered: false
    };
  }
  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  componentDidMount() {
    // prettier-ignore
    (function (w, d, i, s) { function l() { if (!d.getElementById(i)) { var f = d.getElementsByTagName(s)[0], e = d.createElement(s); e.type = "text/javascript", e.async = !0, e.src = "https://canny.io/sdk.js", f.parentNode.insertBefore(e, f) } } if ("function" != typeof w.Canny) { var c = function () { c.q.push(arguments) }; c.q = [], w.Canny = c, "complete" === d.readyState ? l() : w.attachEvent ? w.attachEvent("onload", l) : w.addEventListener("load", l, !1) } })(window, document, "canny-jssdk", "script");
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.data && newProps.data.canny_hash && !this.state.rendered) {
      this.setState({ rendered: true });
      Canny("render", {
        boardToken: BoardToken,
        basePath: "/feedback",
        ssoToken: newProps.data.canny_hash
      });
    }
  }

  render() {
    return <div data-canny />;
  }
}

export default connectToStores(Feedback);



// WEBPACK FOOTER //
// ./src/app/components/feedback.jsx